export const contentElementHelpers = async (err) => {
  if (err) {
    console.error(err);
  }

  /*
   * Click on entire element for:
   * packages preview teaser,
   * accordion,
   * title first tesasers
   * threecol preview teasers
   */
  const clickableContainers = document.querySelectorAll(
    '.fourcol__teaser-slider .wp-block-columns .wp-block-column.swiper__threecol-teasers .swiper-slide .wp-block-group, .packages-preview-teaser .wp-block-columns .wp-block-column, .accordion .wp-block-columns .wp-block-column > .wp-block-group:first-child, .title-first .wp-block-columns .wp-block-column .swiper-wrapper .swiper-slide > .wp-block-group',
  );

  for (var i = 0; i < clickableContainers.length; i++) {
    let teaserItem = clickableContainers[i],
      linkTag = '';

    if (teaserItem.querySelector('.wp-block-button__link')) {
      linkTag = teaserItem.querySelector('.wp-block-button__link');
    }

    if (linkTag) {
      teaserItem.addEventListener('click', (event) => {
        let url = linkTag.getAttribute('href');
        if (url) {
          window.open(url, '_self');
        }

        event.preventDefault();
      });
    }
  }

  /*
   * Click on entire element for:
   * rest api teasers
   */
  // Wait until rest api content is loaded - use a mutation observer
  const restApiContainer = document.querySelector(
    '.rest-api-offers-list, .rest-api-packages-list, .rest-api-events-list',
  );

  if (restApiContainer) {
    const observer = new MutationObserver((mutationsList, observer) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // New nodes have been added, we can add click events now
          addClickEventsToRestApiTeasers();
          // Once done, we can disconnect the observer
          observer.disconnect();
        }
      });
    });

    observer.observe(restApiContainer, {childList: true, subtree: true});
  }

  const addClickEventsToRestApiTeasers = () => {
    const clickableRestApiContainers = document.querySelectorAll(
      '.rest-api-offers-list .wp-block-columns .wp-block-column, .rest-api-packages-list .wp-block-columns .wp-block-column, .rest-api-events-list .swiper-slide > .wp-block-group',
    );

    for (i = 0; i < clickableRestApiContainers.length; i++) {
      let teaserItem = clickableRestApiContainers[i],
        linkTag = '';

      if (teaserItem.querySelector('.wp-block-button__link')) {
        linkTag = teaserItem.querySelector('.wp-block-button__link');
      }

      if (linkTag) {
        teaserItem.addEventListener('click', (event) => {
          let url = linkTag.getAttribute('href');
          if (url) {
            window.open(url, '_self');
          }

          event.preventDefault();
        });
      }
    }
  };

  /*
   * Click on entire element for:
   * query loop posttype teasers
   */
  const posttypeTeaserItems = document.querySelectorAll(
    '.query-loop .wp-block-post',
  );

  for (i = 0; i < posttypeTeaserItems.length; i++) {
    let teaserItem = posttypeTeaserItems[i],
      linkTag = '';
    // Do not add click event to the teaser item if it contains a swiper__posttype-teaser class
    if (!teaserItem.querySelector('.swiper__posttype-teaser')) {
      teaserItem.style.cursor = 'pointer';
      if (teaserItem.querySelector('.wp-block-read-more')) {
        linkTag = teaserItem.querySelector('.wp-block-read-more');
      }

      if (linkTag) {
        teaserItem.addEventListener('click', (event) => {
          let url = linkTag.getAttribute('href');
          if (url) {
            window.open(url, '_self');
          }

          event.preventDefault();
        });
      }
    }
  }

  /*
   * Click on entire element for:
   * shortcut links button
   * cta badge header
   * info badge on subpage headers
   */
  const shortCutLinkItems = document.querySelectorAll(
    '.shortcut-links .wp-block-group p, .header-cta-badge, .info-badge',
  );

  if (shortCutLinkItems) {
    for (i = 0; i < shortCutLinkItems.length; i++) {
      let shortCutLinkItem = shortCutLinkItems[i],
        linkTag = '';

      if (shortCutLinkItem.querySelector('a')) {
        linkTag = shortCutLinkItem.querySelector('a');
      }

      if (linkTag) {
        shortCutLinkItem.addEventListener('click', (event) => {
          let url = linkTag.getAttribute('href');
          if (url) {
            // If the link has target "_blank" attribute, open in new tab
            if (linkTag.getAttribute('target') === '_blank') {
              window.open(url, '_blank');
            } else {
              window.open(url, '_self');
            }
          }

          event.preventDefault();
        });
      }
    }
  }
  /*
   * Click on image or title for:
   * twocol teasers,
   * triple teasers
   * teaser mini images
   */
  const teaserItems = document.querySelectorAll(
    '.twocol__teaser .wp-block-columns .wp-block-column, .triple-teaser-hover .wp-block-columns .wp-block-column, .twocol__teaser-mini-images .wp-block-columns .wp-block-column',
  );

  for (i = 0; i < teaserItems.length; i++) {
    let teaserItem = teaserItems[i],
      linkTag = '',
      titleTag = '',
      imageTag = '';

    if (
      !teaserItem.parentElement.parentElement.classList.contains(
        'no-entire-element-click',
      )
    ) {
      if (teaserItem.querySelector('.wp-block-button__link')) {
        linkTag = teaserItem.querySelector('.wp-block-button__link');
        teaserItem.parentElement.parentElement.classList.add('has-teaser-link');
      }

      if (linkTag) {
        // Add click event to the teaser item Title
        if (teaserItem.querySelector('.wp-block-heading')) {
          titleTag = teaserItem.querySelector('.wp-block-heading');

          titleTag.addEventListener('click', (event) => {
            let url = linkTag.getAttribute('href');
            if (url) {
              window.open(url, '_self');
            }

            event.preventDefault();
          });
        }
      }

      // Add click event to the teaser item Image
      if (teaserItem.querySelector('.wp-block-cover')) {
        imageTag = teaserItem.querySelector('.wp-block-cover');

        imageTag.addEventListener('click', (event) => {
          let linkTag = teaserItem.parentElement.querySelector(
            '.wp-block-button__link',
          );
          let url = linkTag.getAttribute('href');

          if (url) {
            window.open(url, '_self');
          }

          event.preventDefault();
        });
      }
    }
  }
  /*
   * format date inside teaser flag
   */
  const dateFlag = document.querySelectorAll(
    '.custom-posttype-grid-acf-fields span:not(.activity-text-field)',
  );
  if (dateFlag) {
    dateFlag.forEach((flag) => {
      flag.textContent = flag.textContent.substring(0, 6);
    });
  }

  /*
   * Disable past dates for datepicker in booking form
   */
  const datepickers = document.querySelectorAll(
    '.wpcf7-form .form-input-field',
  );
  if (datepickers) {
    datepickers.forEach((datepicker) => {
      const input = datepicker.querySelector('input[type="date"]');
      if (input) {
        const today = new Date().toISOString().split('T')[0];
        input.setAttribute('min', today);
      }
    });
  }
};

import.meta.webpackHot?.accept(contentElementHelpers);
